import { render, staticRenderFns } from "./LoadingFSFB.vue?vue&type=template&id=10d646d0&scoped=true&lang=pug&"
import script from "./LoadingFSFB.vue?vue&type=script&lang=js&"
export * from "./LoadingFSFB.vue?vue&type=script&lang=js&"
import style0 from "./LoadingFSFB.vue?vue&type=style&index=0&id=10d646d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d646d0",
  null
  
)

export default component.exports